import React from 'react'
import { PressWrapper } from '../../components/press/styles'
import Header from '../../components/press/Header'
import PressLinks from '../../components/press/PressLinks'
import { data } from '../../components/press/data'

const Press = () => {
  return (
    <PressWrapper>
      <div className="content">
        <Header />
        <PressLinks {...{ data }} />
      </div>
    </PressWrapper>
  )
}

export default Press
